import React, { useRef, useEffect, useState, forwardRef, useImperativeHandle } from "react";
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

// Custom CSS styles for Quill editor
const quillStyles = `
  .ql-toolbar .ql-color .ql-picker-label svg,
  .ql-toolbar .ql-background .ql-picker-label svg {
    width: 18px !important;
    height: 18px !important;
  }
  .ql-toolbar .ql-color .ql-picker-label,
  .ql-toolbar .ql-background .ql-picker-label {
    width: 28px !important;
    height: 28px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ql-toolbar button,
  .ql-toolbar .ql-picker-label {
    border: 1px solid #dee2e6 !important;
  }
  .ql-toolbar button,
  .ql-toolbar .ql-picker-label {
    border-radius: 4px !important;
  }
  .ql-toolbar button[title]::after,
  .ql-toolbar .ql-picker-label[title]::after {
    content: attr(title);
    position: absolute;
    background: #333;
    color: #fff;
    font-size: 12px;
    padding: 4px 6px;
    border-radius: 4px;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease-in-out;
  }

  .ql-toolbar button:hover::after,
  .ql-toolbar .ql-picker-label:hover::after {
    opacity: 1;
  }



  .quill-editor-container {
    border: 1px solid #dee2e6;
    border-radius: 0.375rem;
    overflow: hidden;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
  
  .quill-editor-container:focus-within {
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  }
  
  .quill-editor-container.is-invalid {
    border-color: #dc3545;
  }
  
  .quill-editor-container.is-invalid:focus-within {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
  }
  
  .ql-toolbar {
    border: none !important;
    border-bottom: 1px solid #dee2e6 !important;
    padding: 12px 16px !important;
    background-color: #f8f9fa;
    border-radius: 0 !important;
  }
  
  .ql-container {
    border: none !important;
    font-family: inherit !important;
    font-size: 14px !important;
    line-height: 1.5 !important;
  }
  
  .ql-editor {
    padding: 16px !important;
    min-height: 200px !important;
    color: #212529 !important;
  }
  
  .ql-editor.ql-blank::before {
    color: #6c757d !important;
    font-style: italic !important;
  }
  
  .ql-toolbar .ql-formats {
    margin-bottom: 4px !important;
    margin-right: 15px !important;
  }
  
  .ql-toolbar .ql-formats:last-child {
    margin-right: 0 !important;
  }
  
  .ql-toolbar button {
    padding: 4px 6px !important;
    margin: 0 2px !important;
    border-radius: 4px !important;
    transition: all 0.15s ease-in-out !important;
  }
  
  .ql-toolbar button:hover {
    background-color: #e9ecef !important;
  }
  
  .ql-toolbar button.ql-active {
    background-color: #0d6efd !important;
    color: white !important;
  }
  .ql-snow .ql-picker{
    height: auto;
  }
  .ql-snow.ql-toolbar button{
    height: 30px;
  }
  
  .ql-toolbar .ql-picker {
    margin: 0 2px !important;
  }
  
  .ql-toolbar .ql-picker-label {
    padding: 4px 8px !important;
    border-radius: 4px !important;
    transition: all 0.15s ease-in-out !important;
  }
  
  .ql-toolbar .ql-picker-label:hover {
    background-color: #e9ecef !important;
  }
  
  .ql-toolbar .ql-picker.ql-expanded .ql-picker-label {
    background-color: #0d6efd !important;
    color: white !important;
  }
  
  .ql-toolbar .ql-picker-options {
    border: 1px solid #dee2e6 !important;
    border-radius: 0.375rem !important;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
    background-color: white !important;
    padding: 4px 0 !important;
  }
  
  .ql-toolbar .ql-picker-item {
    padding: 6px 12px !important;
    transition: background-color 0.15s ease-in-out !important;
  }
  
  .ql-toolbar .ql-picker-item:hover {
    background-color: #f8f9fa !important;
  }
  
  .ql-toolbar .ql-picker-item.ql-selected {
    background-color: #0d6efd !important;
    color: white !important;
  }
  
  .ql-editor h1, .ql-editor h2, .ql-editor h3, .ql-editor h4, .ql-editor h5, .ql-editor h6 {
    font-weight: 600 !important;
    margin-top: 1rem !important;
    margin-bottom: 0.5rem !important;
  }
  
  .ql-editor h1 { font-size: 2rem !important; }
  .ql-editor h2 { font-size: 1.75rem !important; }
  .ql-editor h3 { font-size: 1.5rem !important; }
  .ql-editor h4 { font-size: 1.25rem !important; }
  .ql-editor h5 { font-size: 1.125rem !important; }
  .ql-editor h6 { font-size: 1rem !important; }
  
  .ql-editor p {
    margin-bottom: 1rem !important;
  }
  
  .ql-editor ul, .ql-editor ol {
    padding-left: 1.5rem !important;
    margin-bottom: 1rem !important;
  }
  
  .ql-editor li {
    margin-bottom: 0.25rem !important;
  }
  
  .ql-editor blockquote {
    border-left: 4px solid #dee2e6 !important;
    padding-left: 1rem !important;
    margin: 1rem 0 !important;
    font-style: italic !important;
    color: #6c757d !important;
  }
  
  .ql-editor pre {
    background-color: #f8f9fa !important;
    border: 1px solid #dee2e6 !important;
    border-radius: 0.375rem !important;
    padding: 1rem !important;
    margin: 1rem 0 !important;
    overflow-x: auto !important;
  }
  
  .ql-editor a {
    color: #0d6efd !important;
    text-decoration: underline !important;
  }
  
  .ql-editor a:hover {
    color: #0a58ca !important;
  }
  
  .ql-editor img {
    max-width: 100% !important;
    height: auto !important;
    border-radius: 0.375rem !important;
    margin: 1rem 0 !important;
  }
  
  .ql-editor .ql-video {
    width: 100% !important;
    height: 315px !important;
    margin: 1rem 0 !important;
  }
  
  .ql-snow .ql-tooltip {
    border: 1px solid #dee2e6 !important;
    border-radius: 0.375rem !important;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
    background-color: white !important;
  }
  
  .ql-snow .ql-tooltip input {
    border: 1px solid #dee2e6 !important;
    border-radius: 0.25rem !important;
    padding: 0.375rem 0.75rem !important;
    font-size: 0.875rem !important;
  }
  
  .ql-snow .ql-tooltip a {
    background-color: #0d6efd !important;
    color: white !important;
    border-radius: 0.25rem !important;
    padding: 0.375rem 0.75rem !important;
    text-decoration: none !important;
    font-size: 0.875rem !important;
    transition: background-color 0.15s ease-in-out !important;
  }
  
  .ql-snow .ql-tooltip a:hover {
    background-color: #0a58ca !important;
  }
  
  @media (max-width: 768px) {
    .ql-toolbar {
      padding: 8px 12px !important;
    }
    
    .ql-toolbar .ql-formats {
      margin-bottom: 4px !important;
      margin-right: 8px !important;
    }
    
    .ql-toolbar button {
      padding: 3px 5px !important;
      margin: 0 1px !important;
    }
    
    .ql-editor {
      padding: 12px !important;
    }
  }
`;

// Inject styles into the document
if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.textContent = quillStyles;
  document.head.appendChild(styleElement);
}


const EmailEditor = forwardRef(({ onChange = () => {}, initialHtml = "", placeholder = "Write your email...", isError=false }, ref) => {
    const quillRef = useRef(null);
    const editorRef = useRef(null);

    useEffect(() => {
      if (quillRef.current && !editorRef.current) {
        // Initialize Quill editor
        editorRef.current = new Quill(quillRef.current, {
          theme: 'snow',
          modules: {
            toolbar: [
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              ['bold', 'italic', 'underline', 'strike'],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
              ['blockquote'],
              ['link'],
              ['clean']
            ]
          },
          formats: [
            'header', 'size',
            'bold', 'italic', 'underline', 'strike',
            'color', 'background',
            'script',
            'list', 'bullet', 'indent',
            'direction', 'align',
            'blockquote', 'code-block',
            'link', 'image', 'video'
          ],
          placeholder: 'Write a detailed job description including responsibilities, requirements, and benefits...'
        });

        const toolbar = quillRef.current.querySelector('.ql-toolbar');
        if (toolbar) {
          toolbar.querySelector('.ql-bold')?.setAttribute('title', 'Bold (Ctrl+B)');
          toolbar.querySelector('.ql-italic')?.setAttribute('title', 'Italic (Ctrl+I)');
          toolbar.querySelector('.ql-underline')?.setAttribute('title', 'Underline (Ctrl+U)');
          toolbar.querySelector('.ql-strike')?.setAttribute('title', 'Strikethrough');
          toolbar.querySelector('.ql-color .ql-picker-label')?.setAttribute('title', 'Text Color');
          toolbar.querySelector('.ql-background .ql-picker-label')?.setAttribute('title', 'Background Color');
          toolbar.querySelector('.ql-list[value="ordered"]')?.setAttribute('title', 'Numbered List');
          toolbar.querySelector('.ql-list[value="bullet"]')?.setAttribute('title', 'Bulleted List');
          toolbar.querySelector('.ql-list[value="check"]')?.setAttribute('title', 'Checklist');
          toolbar.querySelector('.ql-blockquote')?.setAttribute('title', 'Blockquote');
          toolbar.querySelector('.ql-link')?.setAttribute('title', 'Insert Link');
          toolbar.querySelector('.ql-clean')?.setAttribute('title', 'Clear Formatting');
        }

        // Set initial content if exists
        if (initialHtml) {
          editorRef.current.root.innerHTML = initialHtml;
        }

        // Handle text changes
        editorRef.current.on('text-change', () => {
          const content = editorRef.current.root.innerHTML;
          onChange(content);
        });
      }

      // Cleanup function
      return () => {
        if (editorRef.current) {
          editorRef.current = null;
        }
      };
    }, []);

    useEffect(() => {
      if (editorRef.current && initialHtml !== editorRef.current.root.innerHTML) {
        editorRef.current.root.innerHTML = initialHtml || '';
      }
    }, [initialHtml]);
  return (
    <div className="my-3">
      <div className={`quill-editor-container ${isError ? "border-danger":""}`} >
        <div 
          ref={quillRef}
          style={{ 
            minHeight: '200px',
            backgroundColor: 'white',
          }}
        />
      </div>
        
    </div>
  );
});

export default EmailEditor;
